<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { FlowContactsWidgetQC } from '@/widgets/Flow'

  useApiRequestsAbort()
</script>

<template>
  <FlowContactsWidgetQC />
</template>
